import constants from '@/project/components/map/constants.js'

export const MAP_CONFIG = {
  defaultMapProvider: 'google', // 'google' ou 'nominatim'
  defaultGeocodeProvider: 'nominatim', // 'google' ou 'nominatim'
  googleApiKey: constants.GOOGLE_MAP.GOOGLE_MAP_API_KEY,
  nominatimUrl: 'https://nominatim.openstreetmap.org/reverse',
}
